<style lang="scss">
.m5.slide-2 {
  background-image: url(../../../assets/module5/slide1/bg-02.jpg);
  background-size: cover;
  background-position: center;
  h1 {
    font-size: 140px;
    color: #3b7fc2;
    transform: none;
    span {
      display: block;
      font-size: 100px;
      transform-origin: 100% 0%;
      transform: rotate(-4deg);
      &:last-child {
        transform: translate(330px, 20px);
        font-size: 200px;
      }
    }
  }
  .title-wrap {
    right: 378px;
    top: 105px;
    position: absolute;
    display: inline-block;
  }
  p {
    font-size: 34px;
    line-height: 40px;
    margin-bottom: 1.5rem;
  }
  .content {
    max-width: 665px;
    position: absolute;
    right: 164px;
    top: 447px;
  }
  .right-text {
    margin-top: 50px;
    text-align: right;
  }
  h2 {
    margin-top: 30px;
    color: #edad0a;
    font-size: 60px;
  }
}
</style>

<template>
  <div class="m5 slide-2">
    <transition name="scale" appear>
      <div class="title-wrap delay-2" v-show="slideIndex == 0">
        <h1 v-html="$t('module5.slide1.heading')"></h1>
      </div>
    </transition>
    <div class="content">
      <transition name="fadeUp" appear>
        <div v-show="slideIndex == 0" class="delay-3">
          <p>{{ $t("module5.slide1.paragraph1") }}</p>
        </div>
      </transition>
      <transition name="fadeUp" appear>
        <div v-show="slideIndex == 0" class="delay-4">
          <p>{{ $t("module5.slide1.paragraph2") }}</p>
        </div>
      </transition>
    </div>
    <transition name="fadeLeft" appear>
      <img
        v-show="slideIndex == 0"
        src="@/assets/module5/slide1/timmy-02.png"
        class="chars delay-"
      />
    </transition>
  </div>
</template>

<script>
export default {
  props: ["slideIndex"]
};
</script>
